import { Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';
import Loading from '../../pages/Loading';

export const RequireAuth = (props) => {
  const { isLoading, isAuthenticated } = useAuth0();
  let location = useLocation();
  const authSearchParams = new URLSearchParams();

  ['invitation', 'organization', 'email'].forEach((param) => {
    const value = new URLSearchParams(location.search).get(param);

    if (value) {
      authSearchParams.set(param, value);
    }
  });

  const authSearch = authSearchParams.toString();

  if (isLoading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <Outlet />;
  }

  return <Navigate to={{ pathname: '/signin', search: authSearch ? `?${authSearch}` : '' }} state={{ from: location }} replace />;
};
